module.exports = __webpack_public_path__ + "static/media/11.754839ea.jpg";